import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { validatePasswordForm } from "../../../../../utils/validation";

const ResetPasswordModal = ({
  show,
  onHide,
  userId,
  userName,
  onReset,
}) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetFormFields = () => {
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    setIsSubmitting(false);
  };

  const handleReset = async () => {
    const validationErrors = validatePasswordForm(newPassword, confirmPassword);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fix the password errors before submitting.");
      return;
    }

    if (!userId) {
      toast.error("User id is missing. Close the modal and try again.");
      return;
    }

    setIsSubmitting(true);
    try {
      const success = await onReset({ id: userId, newPassword });
      if (success) {
        resetFormFields();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const togglePasswordVisibility = (setter, currentState) =>
    setter(!currentState);

  useEffect(() => {
    if (!show) resetFormFields();
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Reset Password <br />{" "}
          <h5>
            User Name: <b>{userName}</b>
          </h5>
          <h6 className="text-muted mb-0">
            User will log in with this User Name.
          </h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formNewPassword">
            <Form.Label className="pt-2">
              New Password <span className="required-field">*</span>
            </Form.Label>
            <div className="input-group">
              <Form.Control
                type={showNewPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  if (errors.newPassword) {
                    setErrors((prev) => ({ ...prev, newPassword: "" }));
                  }
                }}
                placeholder="Enter new password"
                isInvalid={!!errors.newPassword}
              />
              <span
                className="input-group-text"
                onClick={() =>
                  togglePasswordVisibility(setShowNewPassword, showNewPassword)
                }
                style={{ cursor: "pointer" }}
              >
                <i
                  className={
                    showNewPassword ? "ri-eye-line" : "ri-eye-off-line"
                  }
                />
              </span>
            </div>
            {errors.newPassword && (
              <div className="text-danger mt-1">{errors.newPassword}</div>
            )}
          </Form.Group>
          <Form.Group controlId="formConfirmPassword">
            <Form.Label className="pt-2">
              Confirm Password <span className="required-field">*</span>
            </Form.Label>
            <div className="input-group">
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  if (errors.confirmPassword) {
                    setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                  }
                }}
                placeholder="Confirm new password"
                isInvalid={!!errors.confirmPassword}
              />
              <span
                className="input-group-text"
                onClick={() =>
                  togglePasswordVisibility(
                    setShowConfirmPassword,
                    showConfirmPassword
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <i
                  className={
                    showConfirmPassword ? "ri-eye-line" : "ri-eye-off-line"
                  }
                />
              </span>
            </div>
            {errors.confirmPassword && (
              <div className="text-danger mt-1">{errors.confirmPassword}</div>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleReset}
          disabled={isSubmitting || !newPassword || !confirmPassword}
        >
          {isSubmitting ? "Resetting..." : "Reset Password"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetPasswordModal;
